import { gql } from '@apollo/client';
import { LightPersonGroupFragment } from '../../fragments/personGroup/LightPersonGroup';

export const GetLightPersonGroupWithAccessToServiceSubscription = gql`
  query GetLightPersonGroupWithAccessToServiceSubscription(
    $serviceSubscriptionIdentifier: serviceSubscriptionIdentifier!,
    $page: PageInput
  ) {
    lightPersonGroupWithAccessToServiceSubscription(
      serviceSubscriptionIdentifier: $serviceSubscriptionIdentifier
      page: $page
    ) {
      edges {
        node {
          ...LightPersonGroup
        }
      }
      pageInfo {
        hasNextPage
      }
      totalCount
    }
  }
  ${LightPersonGroupFragment}
`;
